













import { Vue, Component, Prop } from 'vue-property-decorator';

import AddLocation from '../../LocationFormModal/Steps/AddLocation.vue';

@Component({
  components: {
    AddLocation
  }
})
export default class CoinNetworkAddLocation extends Vue {
  @Prop() onStepClick?: () => void;
}
